export * from './auswertungen';
